<template>
  <v-card :elevation="permitEdit ? '' : 0">
    <v-container fluid>
      <v-row dense>
        <v-col>
          <v-row dense>
            <v-col>
            <!-- <pre> IF medicineExtraNamexx: {{prescriptionItem.medicineExtraName }}</pre> -->
              <PrescriptionFormItem
                v-if="isEditing"
                :attendance="attendance"
                :prescriptionItem="prescriptionItem"
                :prescriptionId="prescriptionId"
                :prescriptionInput="prescriptionInput"
                :refreshList="refreshList"
                :applicationRoute="applicationRoute"
                :prescriptionFrequencies="prescriptionFrequencies"
                :prescriptionPeriods="prescriptionPeriods"
                :prescriptionHowLongs="prescriptionHowLongs"
                :disabled="disabled"
              />

              <v-row dense v-else>
                <v-col>
                  <v-row dense align="center">
                    <v-col cols="auto">
                      <v-row dense>
                        <v-col cols="auto" class="font-weight-bold">
                          {{ index + 1 }} - 

                          <span v-if="prescriptionItem.medicine.name == 'EXTRA'"> {{ prescriptionItem.medicineExtraName }} </span>
                          <span v-else> {{ prescriptionItem.medicine.name }} </span>
                        </v-col>
                        <v-col cols="auto">
                          {{ prescriptionItem.presentation.name }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col><hr class="dashed-border" /> </v-col>
                    <v-col cols="auto">
                      <v-row dense>
                        <v-col cols="auto">
                          <span v-if="prescriptionItem.continuous">
                            CONTÍNUO
                          </span>
                          <span v-else>
                            {{ prescriptionItem.presentationQuantity }}
                            {{ prescriptionItem.presentationUnity.name }}(s)
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row
                    dense
                    v-for="action in prescriptionItemActions"
                    :key="action.id"
                    class="pl-6"
                  >
                     <v-col cols="auto">
                      {{ action.presentationAction.action }} {{ action.presentationActionQuantity }} {{ action.presentationAction.unity }}(s) {{ lodash.get(action, "period.name", " ") }} {{ action.frequency.name }} {{ action.howLong.name }}
                      <span v-if="prescriptionItem.applicationSite.showNameInPrescriptionActions"> {{ prescriptionItem.applicationSite.name }} </span>
                    </v-col>
                    <!-- <v-col cols="auto">
                      {{ action.presentationAction.action }}
                      {{ action.presentationActionQuantity }}
                      {{ action.presentationAction.unity }}(s)
                    </v-col>

                    <v-col cols="auto">
                     {{ lodash.get(action, "period.name", "-") }}
                    </v-col>

                    <v-col cols="auto"> {{ action.frequency.name }}</v-col>

                    <v-col cols="auto"> {{ action.howLong.name }}</v-col>
                    <v-col
                      v-if="prescriptionItem.applicationSite.showNameInPrescriptionActions"
                      cols="auto"
                    >
                      {{ prescriptionItem.applicationSite.name }}
                    </v-col> -->
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="auto" class="mt-1" v-if="permitEdit && isEditing">

              <v-row dense justify="end">
                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    color="light-red"
                    :attrs="attrs"
                    v-on="on"
                    @click="isEditing = !isEditing"
                  >
                    <v-icon>eva-close-outline</v-icon>
                    </v-btn>
                    </template>
                    <span> fechar janela </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>



            <v-col cols="auto" class="mt-1" v-else-if="permitEdit">
              <v-row dense justify="end">
                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        @click="isEditing = !isEditing"
                        :disabled="disabled"
                      >
                        <v-icon>eva-edit-2-outline</v-icon>
                      </v-btn>
                    </template>

                    <span> Editar </span>
                  </v-tooltip>
                </v-col>

                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        @click="deletePrescriptionItem"
                        :disabled="disabled"
                      >
                        <v-icon>eva-trash-outline</v-icon>
                      </v-btn>
                    </template>

                    <span> Excluir </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col> {{ prescriptionItem.observation }} </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import PrescriptionFormItem from "@/components/prescription/form/item.vue";

import DELETE_PRESCRIPTION_ITEM from "@/graphql/prescription/delete_prescription_item.gql";

export default {
  name: "PrescriptionItem",
  components: {
    PrescriptionFormItem,
  },
  props: {
    attendance: Object,
    prescriptionItem: Object,
    index: Number,
    prescriptionId: String,
    prescriptionInput: Object,
    permitEdit: {
      type: Boolean,
      default: true,
    },
    refreshList: {
      type: Function,
      default: () => {},
    },
    medicineApplicationRoutes: {
      type: Array,
      default: () => [],
    },
    prescriptionFrequencies: {
      type: Array,
      default: () => [],
    },
    prescriptionPeriods: {
      type: Array,
      default: () => [],
    },
    prescriptionHowLongs: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEditing: false,
    };
  },
  computed: {
    applicationRoute() {
      return this.lodash.find(this.medicineApplicationRoutes, {
        id: this.prescriptionItem.applicationRoute.id,
      });
    },
    prescriptionItemActions() {
      return this.lodash.orderBy(
        this.prescriptionItem.actions,
        ["createdAt"],
        ["asc"]
      );
    },
  },
  methods: {
    deletePrescriptionItem() {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: DELETE_PRESCRIPTION_ITEM,
        variables: {
          prescriptionItemId: this.prescriptionItem.id,
        },
      }).then(() => {
        this.refreshList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashed-border {
  border-top: 2px dotted #000;
}
</style>
